<template>
  <div>
    <p class="cm-mg-p-wzd">2.1 {{ $t('pqr.pqr_position_info') }}</p>
    <hr />
    <div class="row">
      <select-component
        :rowClass="`col-12 col-sm-6 col-md-2 col-xl-2`"
        :isMultiple="false"
        :labelSelect="`${$t('pqr.week_cut_short')}: *`"
        :dataOptions="weekList"
        :requireClass="`required-cutting-week`"
        :initialSelection="model.cutting_week"
        @onChange="handleChangeSelected"
        modelName="cutting_week"
        valueLabel="option"
        valueOption="option"
      />
      <select-component
        :rowClass="`col-12 col-sm-6 col-md-2 col-xl-2`"
        :isMultiple="false"
        :labelSelect="`${$t('pqr.week_arrival_short')}: ${
          allRequired ? '*' : ''
        }`"
        :dataOptions="arrivalWeekList"
        :requireClass="`${allRequired ? 'required-arrival-week' : ''}`"
        :initialSelection="model.arrival_week"
        @onChange="handleChangeSelected"
        modelName="arrival_week"
        valueLabel="option"
        valueOption="option"
      />
      <div class="col-12 col-sm-6 col-md-2 col-xl-2">
        <div class="form-group">
          <fg-input
            type="number"
            :label="`${$t('pqr.quantity_in_boxes')}: *`"
            v-model="model.boxes_quantity"
            name="pqr.quantity_in_boxes"
            v-validate="'required|integer|min_value:1'"
            :error="getError('pqr.quantity_in_boxes', true)"
          >
          </fg-input>
        </div>
      </div>
      <select-component
        :rowClass="`col-12 col-sm-6 col-md-6 col-xl-6`"
        :isMultiple="false"
        :dataOptions="boxes"
        :requireClass="`required-box-id`"
        @onChange="handleChangeSelected"
        :labelSelect="`${$t('common_words.reference')}: *`"
        modelName="box_id"
        :initialSelection="model.box_id"
      />
      <select-component
        :rowClass="`col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4`"
        :dataOptions="farms"
        :requireClass="`required-container-farm`"
        @onChange="handleChangeSelected"
        :labelSelect="`${$t('common_words.farms2')}: *`"
        modelName="container_farm"
        :initialSelection="model.container_farm"
      />
      <div :class="`col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2`">
        <div class="form-group">
          <label>{{ $t('pqr.container_number_id') }}: *</label>
          <fg-input
            type="text"
            v-model="model.container_num"
            v-maska="'AAAA ######-#'"
            placeholder="ABCD 123456-7"
            name="pqr.container"
            v-validate="'required'"
            :error="getError('pqr.container', true)"
          >
          </fg-input>
        </div>
      </div>
      <div :class="`col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3`">
        <div class="form-group">
          <label
            >{{ $t('pqr.thermograph_number') }}:
            {{ allRequired ? '*' : '' }}</label
          >
          <el-input
            v-model="model.thermograph_num"
            class="input-with-select"
            type="number"
            min="0"
            step="0.01"
            name="Termografo"
            v-validate="allRequired ? 'required' : ''"
          >
            <el-select
              v-model="model.type_temperature"
              slot="prepend"
              style="width: 70px"
            >
              <el-option label="F°" value="fahrenheit"></el-option>
              <el-option label="C°" value="celsius"></el-option>
            </el-select>
          </el-input>
          <span
            v-if="errors.has('Termografo')"
            style="
              color: #c63d2f;
              font-size: 0.875em;
              display: block;
              padding: 10px;
            "
            >{{ errors.first('Termografo') }}</span
          >
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-xl-3">
        <div class="form-group">
          <fg-input
            type="number"
            :label="`${$t('common_words.value')}: ${allRequired ? '*' : ''}`"
            v-model="model.value"
            name="common_words.value"
            v-validate="allRequired ? 'required|min_value:1' : 'min_value:1'"
            :error="getError('common_words.value', true)"
          >
          </fg-input>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-4 col-md-3 col-xl-3">
        <div class="form-group">
          <fg-input
            type="text"
            :label="`${$t('pqr.credit_note')}: ${allRequired ? '*' : ''}`"
            v-model="model.credit_note"
            name="pqr.credit_note"
            v-validate="allRequired ? 'required' : ''"
            :error="getError('pqr.credit_note', true)"
          >
          </fg-input>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-xl-3">
        <div class="form-group has-label shadow-sm">
          <label>
            {{ $t('common_words.date') }} {{ $t('pqr.credit_note') }}:
            {{ this.allRequired ? '*' : '' }}
          </label>
          <el-date-picker
            v-if="renderComponent"
            class="required-date-credit-note"
            :picker-options="pickerOptions"
            v-model="model.date_credit_note"
            type="datetime"
            :placeholder="`${$t('common_words.date_hour_select')}...`"
          >
          </el-date-picker>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import { maska } from 'maska';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import moment from 'moment';

export default {
  directives: { maska },

  data() {
    return {
      allRequired: false,
      boxes: [],
      farms: [],
      weekList: [],
      arrivalWeekList: [],
      editForm: {},
      model: {
        container_farm: null,
        container_num: null,
        thermograph_num: null,
        type_temperature: 'fahrenheit',
        cutting_week: null,
        arrival_week: null,
        box_id: null,
        boxes_quantity: null,
        value: null,
        credit_note: null,
        date_credit_note: null,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },

  mixins: [MixinPermissions, MixinForm, mixinMasters],

  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    handleChangeSelected(data) {
      if (data.name === 'cutting_week') {
        this.model.arrival_week = null;
        this.arrivalWeekList = this.weekList.slice(
          0,
          this.weekList.indexOf(data.selects) + 1
        );
      }
      this.$set(this.model, data.name, data.selects);
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((responseInputs) => {
          this.$emit('on-validated', responseInputs, {
            ...this.model,
            boxSelected: this.model.box_id
              ? this.getNameSelected(this.model.box_id, this.boxes)
              : null,
            farmsContainerSelected: this.model.container_farm
              ? this.getNameSelected(this.model.container_farm, this.farms)
              : null,
          });

          return responseInputs;
        })
        .then((responseSelects) => {
          if (!responseSelects) return responseSelects;
          if (!isset(this.model.box_id)) {
            return this.validationInputsRequired('box-id');
          } else if (!isset(this.model.cutting_week)) {
            return this.validationInputsRequired('cutting-week');
          } else if (!isset(this.model.container_farm)) {
            return this.validationInputsRequired('container-farm');
          }
          if (this.allRequired) {
            if (!isset(this.model.arrival_week)) {
              return this.validationInputsRequired('arrival-week');
            } else if (!isset(this.model.date_credit_note)) {
              return this.validationInputsRequired('date-credit-note');
            } else return true;
          } else return true;
        });
    },

    getWeekList() {
      const currentDate = moment();
      const years = [currentDate.year(), currentDate.year() - 1];
      const weekList = [];

      years.forEach((year) => {
        const weeksInYear = moment(`${year}-12-31`).isoWeek();
        const currentWeek =
          year === currentDate.year() ? currentDate.isoWeek() : weeksInYear;

        for (let week = currentWeek; week >= 1; week--) {
          const formattedWeek = `${year}${week < 10 ? '0' : ''}${week}`;
          weekList.push(formattedWeek);
        }
      });

      return weekList;
    },

    formatContainerNumber(containerNum) {
      const prefijo = containerNum.slice(0, 4);
      const num = containerNum.slice(4, 10);
      const sufijo = containerNum.slice(10, 11);

      const res = `${prefijo} ${num}-${sufijo}`;

      return res;
    },
  },

  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('boxes/indexboxesnameswithcode'),
        Axios.getMasters('farms/farms/onlyfruit'),
      ])
        .then(([boxesResponse, farmsResponse]) => {
          this.boxes = boxesResponse.data.data;
          this.farms = this.concatAll(farmsResponse.data.data);
        })
        .catch((error) => this.showMessageErrors(error));

      this.showHideLoading();
    } else this.showHideLoading();
  },

  mounted() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      this.editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.container_num = this.formatContainerNumber(
        this.editForm.containers[0].pivot.container_num
      );
      this.model.thermograph_num =
        this.editForm.containers[0].pivot.thermograph_num;
      this.model.type_temperature =
        this.editForm.containers[0].pivot.type_temperature;

      const {
        cutting_week,
        arrival_week,
        box_id,
        boxes_quantity,
        value,
        credit_note,
        date_credit_note,
        containers,
      } = this.editForm;

      this.model = {
        ...this.model,
        cutting_week,
        arrival_week,
        box_id,
        boxes_quantity,
        value,
        credit_note,
        date_credit_note,
        container_farm: containers.map((item) => item.id),
      };

      this.weekList = this.getWeekList();
      this.arrivalWeekList = this.weekList.slice(
        0,
        this.weekList.indexOf(String(this.model.cutting_week)) + 1
      );
    }
  },
};
</script>
